// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Loder_loaderContainer__rQVMj","loaderContainer2":"Loder_loaderContainer2__ssxFY","loader":"Loder_loader__MJEUJ","l5":"Loder_l5__4SsiQ"};